import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

const TOAST_BASE: Partial<IndividualConfig> = {
  closeButton: true,
  tapToDismiss: true,
  progressBar: true,
  timeOut: 4500,
  extendedTimeOut: 1500,
  titleClass: 'valvur-toast__title',
  messageClass: 'valvur-toast__message',
};

@Injectable({ providedIn: 'root' })
export class AppToasterService {
  constructor(private toastr: ToastrService) {}

  success(
    message: string,
    title?: string,
    options?: Partial<IndividualConfig>,
  ): void {
    this.toastr.success(message, title ?? '', {
      ...TOAST_BASE,
      ...options,
      toastClass: 'valvur-toast valvur-toast--success ngx-toastr',
    });
  }

  error(
    message: string,
    title?: string,
    options?: Partial<IndividualConfig>,
  ): void {
    this.toastr.error(message, title ?? 'Error', {
      ...TOAST_BASE,
      timeOut: 6000,
      ...options,
      toastClass: 'valvur-toast valvur-toast--error ngx-toastr',
    });
  }

  info(
    message: string,
    title?: string,
    options?: Partial<IndividualConfig>,
  ): void {
    this.toastr.info(message, title ?? '', {
      ...TOAST_BASE,
      ...options,
      toastClass: 'valvur-toast valvur-toast--info ngx-toastr',
    });
  }

  warning(
    message: string,
    title?: string,
    options?: Partial<IndividualConfig>,
  ): void {
    this.toastr.warning(message, title ?? '', {
      ...TOAST_BASE,
      ...options,
      toastClass: 'valvur-toast valvur-toast--warning ngx-toastr',
    });
  }
}
